export default __webpack_public_path__ + "locales/profile.kk.json";